import React from "react"

export const PrismicImage = ({ url }) => {
  return (
    <img
      src={url}
      alt={""}
      className="gatsby-image-wrapper"
      style={{ width: "100%", height: "auto" }}
    />
  )
}

export const BasicImage = ({ url }) => {
  return (
    <img
      src={url}
      alt={""}
      className="gatsby-image-wrapper"
      style={{ width: "100%", height: "auto" }}
    />
  )
}

const getPagePath = ({ type, uid }) => {
  switch (type) {
    case "standard_page":
      return `/${uid}`
    case "blog_portal":
      return `/resources`
    case "blog_post":
      return `/resources/${uid}`
    default:
      return `/${uid}`
  }
}

export const usePrismicPath = ({ url, document, children, ...props }) => {
  const linkURL = url ? url : document ? getPagePath(props) : null
  return linkURL
}
